import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  secondToTime,
  returnDate,
  convertToSlug,
  redirectToUrl,
  sanitizeAndProcessHtml
} from "../../../../util/commonFunctions";
import { showLoader, hideLoader } from "../../../../actions";
import LazyLoad from 'react-lazyload';

/**
 * 
 * @param {*} props 
 * @returns 
 */
const RenderSearchResults = props => {
  return Array.isArray(props.listing)
    ? props.listing.map( (value, index) => {
      return (
        <div key={value.id} className="row searchResult no-gutter ">
          <div className="col col-sm-4 col-md-3 col-lg-2">
            <Link
              className="searchResultImage"
              to={
                "/media/" +
                convertToSlug(value.title) +
                "?videoId=" +
                value.id
              }
            >
              <LazyLoad
                offset={50}
                once={true}
                key={index}
                height={200}
                placeholder={<img src="/assets/svg/abiz_placeholder.svg" className="img-fluid" />}
                debounce={500}
              >
                <img
                  src={value.poster_image}
                  className="img-fluid"
                  alt="Responsive image"
                  width="1024px"
                  height="576px"
                />
              </LazyLoad>
              <div className="duration">
                <span></span>
                {secondToTime(value.duration)}
              </div>
            </Link>
          </div>
          <div className="col col-sm-8 col-md-9 col-lg-10 searchContent">
            {value.topic.name && value.topic.id && 
              <h3 className="topic nodisplayMobile">
                <a
                  href={`/topic/${value.topic.name}/${value.topic.id}`}
                  onClick={event =>
                    redirectToUrl(
                      event,
                      value.topic.id,
                      props,
                      props.showLoader,
                      props.hideLoader,
                      props.currentLanguage
                    )
                  }
                >
                  {value.topic.name}
                </a>
              </h3>
            }
            <h4 className="heading">
              <Link
                to={
                  "/media/" +
                  convertToSlug(value.title) +
                  "?videoId=" +
                  value.id
                }
                style={{
                  color: "inherit"
                }}
              >
                {value.title}
              </Link>
            </h4>
            <Link  
              to={
                "/media/" +
                convertToSlug(value.title) +
                "?videoId=" +
                value.id
              }
              style={{
                color: "inherit"
              }}
            >
              <p className={`${value.summary.length > 1000 ? "description-container-ellipsis" : ""}  description-container`} dangerouslySetInnerHTML={{ __html: sanitizeAndProcessHtml(value.summary)}}></p>
            </Link>
            <div className="d-flex justify-content-between justify-content-md-start marTop25">
              <h5 className="displayMobile">
                <a
                  href={`/topic/${value.topic.name}/${value.topic.id}`}
                  onClick={event =>
                    redirectToUrl(
                      event,
                      value.topic.id,
                      props,
                      props.showLoader,
                      props.hideLoader,
                      props.currentLanguage
                    )
                  }
                >
                  {value.topic.name}
                </a>
              </h5>
              <span className="time">{returnDate(value.publish_date)}</span>
            </div>
          </div>
        </div>
      );
    })
    : null;
};

const mapStateToProps = state => {
  return {
    currentLanguage: state.language.currentLanguage
  };
};


const mapDispatchToProps = dispatch => {
  return {
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RenderSearchResults));
